<template>
    <div class="global-content">
        <div class="type-content">
            <h1 class="">基础模块（多选）</h1>
            <ul>
                <li
                    v-for="(item, index) in commonType"
                    :class="{
                        future: item.status == 2,
                        future1: item.status == 3,
                        lock: item.lock,
                    }"
                    @click="commonTypeSelect(index, item.lock)"
                    :key="index"
                >
                    <img v-if="item.lock" src="../../../static/images/locking-w.png" alt="" />
                    <i
                        :class="[{ active: item.select }, item.img]"
                        class="iconfont icon"
                        :style="{ height: height + 'px' }"
                    ></i>
                    <div style="position: absolute" v-if="item.status == 3">
                        <i :class="['panda_mobilelocking']" class="iconfont iconSmall"></i>
                    </div>
                    <div style="margin-top: 0.15rem">
                        <span :class="{ active: item.select }" class="select">
                            <i class="iconfont panda_mobileduihao sel"></i>
                        </span>
                        <span class="name">{{
                            item.status == 2
                                ? item.moduleName + '(升级中)'
                                : item.status == 3
                                ? item.moduleName + '(待解锁)'
                                : item.moduleName
                        }}</span>
                    </div>
                </li>
            </ul>
            <div class="border"></div>
            <h1 class="">行业模块（单选）</h1>
            <ul>
                <li
                    v-for="(item, index) in professionType"
                    :class="{
                        future: item.status == 2,
                        future1: item.status == 3,
                        lock: item.lock,
                    }"
                    @click="professionTypeSelect(index, item.lock)"
                    :key="index"
                >
                    <img v-if="item.lock" src="../../../static/images/locking-w.png" alt="" />

                    <i
                        :class="[{ active: item.select }, item.img]"
                        class="iconfont icon"
                        :style="{ height: height + 'px' }"
                    ></i>
                    <div style="position: absolute" v-if="item.status == 3">
                        <i :class="['panda_mobilelocking']" class="iconfont iconSmall"></i>
                    </div>
                    <div style="margin-top: 0.15rem">
                        <span :class="{ active: item.select }" class="select">
                            <i class="iconfont panda_mobileduihao sel"></i>
                        </span>
                        <span class="name">{{
                            item.status == 2
                                ? item.moduleName + '(升级中)'
                                : item.status == 3
                                ? item.moduleName + '(待解锁)'
                                : item.moduleName
                        }}</span>
                    </div>
                </li>
            </ul>
            <a-form-item style="margin-top: 0.2rem">
                <div class="button_view">
                    <div class="question-time">
                        <span v-show="getEstimatedShow"
                            >共 {{ getEstimatedSum }} 自检题，预计耗时
                            {{ getEstimatedTime }} 分钟</span
                        >
                    </div>
                    <a-button
                        type="primary"
                        style="margin-right: 1rem"
                        class="my-btn"
                        @click="toQuestion"
                    >
                        开始自检
                    </a-button>
                    <a-button type="default" size="large" class="my-btn" @click="cancelSelect">
                        取消选择
                    </a-button>
                </div>
            </a-form-item>
        </div>
    </div>
</template>

<script>
    import { apiListPC } from '@/api'
    import ajax from '@/api/ajax'

    import { ICON_FONT_IMG_MAP } from '@/utils/public'
    import { lockUniversalModule, lockIndustryModule } from '@/utils/lockModule/lockModule.js'

    export default {
        name: 'Type',
        async mounted() {
            document.body.style.overflow = 'auto'
            this.enterpriseCode = this.$route.params.enterpriseCode
            this.enterpriseName = this.$route.params.enterpriseName

            this.getIndustryModule()
        },
        data() {
            return {
                enterpriseCode: '',
                enterpriseName: '',
                commonType: [],
                professionType: [],
                height: 0,
                getEstimatedTime: 0,
                getEstimatedSum: 0,
                getEstimatedShow: false,
            }
        },
        methods: {
            commonTypeSelect(index, lock) {
                if (lock) {
                    this.$message.warning(
                        '您的服务已到期，部分功能已受限，如有问题，请联系工作人员',
                        2
                    )
                    return
                }
                this.commonType[index].select = !this.commonType[index].select
                this.getEstimatedData()
            },
            professionTypeSelect(index, lock) {
                if (lock) {
                    this.$message.warning(
                        '您的服务已到期，部分功能已受限，如有问题，请联系工作人员',
                        2
                    )
                    return
                }
                this.professionType.forEach((i) => {
                    i.select = false
                })
                this.professionType[index].select = true
                this.getEstimatedData()
            },
            async getEstimatedData() {
                let modules = []
                this.commonType.forEach(function (item) {
                    if (item.select == true) {
                        modules.push(item.moduleId)
                    }
                })
                this.professionType.forEach(function (item) {
                    if (item.select == true) {
                        modules.push(item.moduleId)
                    }
                })
                if (modules.length == 0) {
                    this.getEstimatedShow = false
                    return
                }
                const moduleIdList = modules.filter((i) => i > 0)

                let data = await ajax(apiListPC.getTime, { moduleIds: moduleIdList }, 'POST')
                this.getEstimatedShow = true
                this.getEstimatedTime = data.data.time
                this.getEstimatedSum = data.data.count
            },
            cancelSelect() {
                this.commonType.forEach((i) => {
                    i.select = false
                })
                this.professionType.forEach((i) => {
                    i.select = false
                })
                this.getEstimatedData()
            },
            async toQuestion() {
                let modules = []
                this.commonType.forEach((item) => {
                    if (item.select == true) {
                        modules.push(item.moduleId)
                    }
                })
                this.professionType.forEach((item) => {
                    if (item.select == true) {
                        modules.push(item.moduleId)
                    }
                })
                if (modules.length == 0) {
                    this.$message.warning('至少选择一项自检项目')
                    return
                }

                const moduleIdList = modules.filter((i) => i > 0)

                sessionStorage.setItem('modules', moduleIdList)
                sessionStorage.setItem('from', 'Type')

                await this.addModuleToSurvey(moduleIdList)
                this.$router.replace('/Question')
            },
            getIndustryModule() {
                const paramsData = { license: sessionStorage.getItem('license') }
                ajax(apiListPC.getIndustryModule, paramsData).then((res) => {
                    // const defaultModule = {
                    //   moduleId: "-1",
                    //   moduleName: "通用行业",
                    //   operator: null,
                    //   status: "1",
                    // };

                    // if (res.data.length < 1) {
                    //   this.professionType = []
                    //   return false
                    // }

                    let moduleData = [...res.data]
                        .map((item) => {
                            item.select = item.moduleId == '-1' && item.status == 1 ? true : false
                            item.img = ICON_FONT_IMG_MAP[item.moduleId] || 'panda_mobilebumen-moren'
                            return item
                        })
                        .filter((item) => !item.operator)

                    this.professionType = lockIndustryModule(moduleData, this.$lock)

                    this.addSurvey()
                })
            },
            addSurvey() {
                let paramsData = new FormData()
                paramsData.append('license', sessionStorage.getItem('license'))
                paramsData.append('enterpriseId', sessionStorage.getItem('enterpriseId'))
                paramsData.append('surveyName', sessionStorage.getItem('fullName'))
                // paramsData.append('moduleVersion', 1);

                ajax(apiListPC.addSurvey, paramsData, 'POST').then((res) => {
                    // sessionStorage.setItem('enterpriseId', '60')
                    sessionStorage.setItem('surveyId', res.data)
                    this.getModuleBySurveyId(res.data)
                })
            },
            getModuleBySurveyId(_surveyId) {
                const paramsData = {
                    license: sessionStorage.getItem('license'),
                    surveyId: _surveyId,
                    moduleVersion: 1,
                }
                ajax(apiListPC.getModuleBySurveyId, paramsData).then((res) => {
                    if (res.data.length < 1) {
                        this.commonType = []
                        return false
                    }

                    let moduleData = res.data.map((item) => {
                        item.select = false
                        item.img = ICON_FONT_IMG_MAP[item.moduleId] || 'panda_mobilebumen-moren'
                        return item
                    })

                    this.commonType = lockUniversalModule(moduleData, this.$lock)
                    // console.log(this.commonType)
                })
            },
            addModuleToSurvey(_moduleIdList) {
                const paramsData = {
                    surveyId: sessionStorage.getItem('surveyId'),
                    moduleVersion: '1',
                    moduleIdList: _moduleIdList,
                }
                ajax(apiListPC.addModuleToSurvey, paramsData, 'POST')
            },
        },
        beforeMount() {
            const { enterpriseId, fullName } = this.$route.query
            if (enterpriseId || fullName) {
                sessionStorage.setItem('enterpriseId', enterpriseId)
                sessionStorage.setItem('fullName', fullName)
            }
        },
    }
</script>

<style lang="less" type="text/less" scoped>
    .future {
        pointer-events: none;
        i {
            background-color: #dcdcdc !important;
        }
    }
    .lock {
        .icon {
            background-color: #e3e4e5 !important;
            color: #fff;
        }
    }
    .future1 {
        pointer-events: none;
    }
    .global-content {
        margin: 0 auto;
        width: 100%;
        padding-top: 1px;
        background: #fff;
        //padding-bottom: 60px;
        .type-content {
            width: 85%;
            margin: 30px auto 0;
            padding: 0 0 0.1rem 0;

            h1 {
                text-align: left;
                font-size: 0.28rem;
                text-indent: 0.34rem;
                color: #272727;
            }
            .border {
                margin: 0.2rem 0.34rem 0.34rem;
                border-top: 1px solid #ddd;
            }
            .my-btn {
                width: 2rem;
                height: 0.5rem;
                font-size: 0.2rem;
            }
            ul {
                width: auto;
                margin: 0 0.34rem;
                padding: 0;

                &:after {
                    content: '';
                    height: 0;
                    display: block;
                    clear: both;
                }
                li {
                    list-style: none;
                    width: 10%;
                    margin-right: 8%;
                    float: left;
                    margin-bottom: 0.1rem;
                    position: relative;
                    cursor: pointer;
                    //height: 2.2rem;
                    img {
                        width: 30px;
                        height: 30px;
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        z-index: 2;
                    }
                    &:nth-child(6n + 6) {
                        margin-right: 0;
                    }
                    .icon {
                        display: block;
                        background: #f5f6fd;
                        font-size: 0.5rem;
                        /*padding:0.3rem 0;*/
                        padding-top: 100%;
                        border-radius: 4px;
                        position: relative;
                        &:before {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            margin-top: -0.36rem;
                            margin-left: -0.25rem;
                        }
                        &.active {
                            background: @primary-color;
                            color: #fff;
                        }
                    }
                    .iconSmall {
                        position: relative;
                        font-size: 0.2rem;
                        display: block;
                        margin-left: 13.5vh;
                        margin-top: -16vh;
                    }

                    .name {
                        margin-top: 0.3rem;
                    }

                    .select {
                        display: none;
                        width: 0.4rem;
                        height: 0.4rem;
                        background: @primary-color;
                        border: 2px solid #fff;
                        color: #fff;
                        position: absolute;
                        top: -0.12rem;
                        right: -0.12rem;
                        border-radius: 50%;
                        i {
                            font-size: 0.3rem;
                            position: relative;
                            top: -0.03rem;
                        }
                        &.active {
                            display: block;
                        }
                    }
                }
            }

            .btnGroup1 {
                width: auto;
                margin: 0.5rem 0.34rem 0.2rem;
                div {
                    margin-right: 20px;
                    float: left;
                    display: block;
                    width: calc(50% - 10px);
                    height: 0.83rem;
                    &:nth-child(2) {
                        margin-right: 0;
                    }
                    button {
                        width: 100%;
                        height: 0.83rem;
                        font-size: 0.28rem;
                        &.mybtn {
                            border-color: @primary-color;
                            color: @primary-color;
                            background: #f5f6fd;
                        }
                    }
                }
            }
        }
    }

    .question-time {
        text-align: left;
        height: 40px;
        color: @primary-color;
    }
    .button_view {
        display: inline-block;
    }
</style>
